import React, { ReactNode } from 'react'

import classnames from 'classnames'
import { Text } from '@components/text'

import styles from './styles.module.scss'
import Link from 'next/link'

interface HeaderSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
  onPress?: string
  sendTo?: string
  currentDate?: boolean
}

export const HeaderSection = ({
  children,
  onPress,
  sendTo,
  currentDate = false,
  className,
  ...rest
}: HeaderSectionProps): JSX.Element => (
  <div
    className={classnames(
      className,
      styles.container,
      children ? 'flex justify-between' : 'hidden md:flex justify-end'
    )}
    {...rest}
  >
    {sendTo ? <Link href={sendTo}>{children}</Link> : <>{children}</>}

    <div className={styles.textContent}>
      {onPress && sendTo && (
        <Link href={sendTo} className={styles.headerSectionLink}>
          {onPress}
        </Link>
      )}
      {currentDate && (
        <Text textType="title" fontWeight="regular">
          {Intl.DateTimeFormat('pt-BR', { dateStyle: 'full' }).format(
            Date.now()
          )}
        </Text>
      )}
    </div>
  </div>
)
